/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_Faq_1_AInputs */

const en_vc_onl_faq_1_a = /** @type {(inputs: Vc_Onl_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. It is free and open source, with no sign-up, no watermark and no limits on what you can export.`)
};

const zh_vc_onl_faq_1_a = /** @type {(inputs: Vc_Onl_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费。它是免费开源软件，不用注册、没有水印，导出也没有任何限制。`)
};

/**
* | output |
* | --- |
* | "Yes. It is free and open source, with no sign-up, no watermark and no limits on what you can export." |
*
* @param {Vc_Onl_Faq_1_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_faq_1_a = /** @type {((inputs?: Vc_Onl_Faq_1_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_Faq_1_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_faq_1_a(inputs)
	return zh_vc_onl_faq_1_a(inputs)
});
export { vc_onl_faq_1_a as "vc.onl.faq.1.a" }